//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import RequestWorkTypesList from '../../../forms/Request/RequestWorkTypesList.vue'

export default {
  components: {
    RequestWorkTypesList
  },
  props: {
    requests: {
      type: Array,
      default: () => []
    }
  }
}

